import React from "react";

const C1BenefitsMain = () => {
  return (
    <div className="LvlBenefitsMainContainer">
      <ul>
        <li>
          <span>🎓 Study at a German University: </span>This course prepares you
          to meet the language requirements for higher education in Germany.
        </li>
        <li>
          <span>📖 Advanced Comprehension: </span>
          Understand a wide range of demanding, longer texts and recognize
          implicit meanings with ease.
        </li>
        <li>
          <span>🗣️ Fluent Expression: </span>
          Express your ideas spontaneously and fluently without searching for
          words.
        </li>
        <li>
          <span>🌍 Versatile Communication: </span>
          Speak confidently in social, professional, and economic scenarios.
        </li>
        <li>
          <span>📚 Information Synthesis :</span>
          Summarize information from various spoken and written sources
          effectively.
        </li>
        <li>
          <span>📊 Professional Presentations: </span>
          Create detailed presentations and reports with confidence and
          precision.
        </li>
        <p>
          Join Prizma Academy to elevate your German proficiency to an advanced
          level and unlock numerous opportunities!
        </p>
      </ul>
    </div>
  );
};

export default C1BenefitsMain;
